<template>
  <v-app>
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row>
          <v-col cols="12" sm="8" offset-sm="2">
            <v-slide-y-transition>
              <div align="center" class="mb-2">
                <div class="display-1">Thanks for Participating to Sonic Club's Discord Emoji Workshop 2020 Event!</div>
                <div class="subtitle-1" v-show="maxSelected">Here are the top 12 chosen emoji!</div>
                <div class="subtitle-1" v-show="!maxSelected">Here are all the emojis created this year. Hover for author info. Click on any of them to see the voting results!</div>
              </div>
            </v-slide-y-transition>
            <v-card>
              <v-container fluid>
                <v-row :justify="maxSelected ? 'center' : null" dense>
                  <v-col v-if="!ready" class="my-8" align="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-col>
                  <v-col
                    v-for="imgId in displayedIds"
                    :key="imgId"
                    class="d-flex child-flex"
                    cols="3"
                    lg="2"
                    xl="1"
                  >
                    <v-card flat tile class="d-flex" @click="handleImageClick(imgId)">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-img
                            v-on="on"
                            :src="require(`./assets/${images[imgId].file}`)"
                            aspect-ratio="1"
                            :gradient="!maxSelected && selectedIds.includes(imgId) ? 'to top right, rgba(0,100,0,0.1), rgba(0,200,0,0.5)' : null"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </template>
                        <span>#{{imgId}} by {{images[imgId].author}} ({{ images[imgId].discordId }})</span>
                      </v-tooltip>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import debounce from 'lodash.debounce';
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    ready: false,
    maxSelectionCount: 6,
    images: {
      1: {
        file:'1.png',
        author: 'First Sketchy, King of the Buns',
        discordId: 'Sketchy Boi#6551',
      },
      2: {
        file:'2.png',
        author: 'poop dealer',
        discordId: '🌌💮𝓢𝐏ε𝓵ｌ 🔮ғ𝕋𝒽𝐞𝓓έ𝐚ｄ🌸🌆🌇🌺#9380',
      },
      3: {
        file:'3.png',
        author: 'First Sketchy, King of the Buns',
        discordId: 'Sketchy Boi#6551',
      },
      4: {
        file:'4.png',
        author: 'Nini Rosé',
        discordId: 'Nini Rosé#9592',
      },
      5: {
        file:'5.gif',
        author: 'Flamestream 🔥',
        discordId: 'Flamestream#3806',
      },
      6: {
        file:'6.gif',
        author: 'min',
        discordId: 'min#1000',
      },
      7: {
        file:'7.png',
        author: 'Hanny',
        discordId: 'Hanny#2852',
      },
      8: {
        file:'8.png',
        author: 'min',
        discordId: 'min#1000',
      },
      9: {
        file:'9.png',
        author: 'min',
        discordId: 'min#1000',
      },
      10: {
        file:'10.png',
        author: 'poop dealer',
        discordId: '🌌💮𝓢𝐏ε𝓵ｌ 🔮ғ𝕋𝒽𝐞𝓓έ𝐚ｄ🌸🌆🌇🌺#9380',
      },
      11: {
        file:'11.png',
        author: 'poop dealer',
        discordId: '🌌💮𝓢𝐏ε𝓵ｌ 🔮ғ𝕋𝒽𝐞𝓓έ𝐚ｄ🌸🌆🌇🌺#9380',
      },
      12: {
        file:'12.png',
        author: 'Mllermanda',
        discordId: 'Mllermanda#5240',
      },
      13: {
        file:'13.png',
        author: 'Mllermanda',
        discordId: 'Mllermanda#5240',
      },
      14: {
        file:'14.png',
        author: 'Mllermanda',
        discordId: 'Mllermanda#5240',
      },
      15: {
        file:'15.png',
        author: 'Mllermanda',
        discordId: 'Mllermanda#5240',
      },
      16: {
        file:'16.png',
        author: 'Mllermanda',
        discordId: 'Mllermanda#5240',
      },
      17: {
        file:'17.png',
        author: 'Mllermanda',
        discordId: 'Mllermanda#5240',
      },
      18: {
        file:'18.png',
        author: 'Flamestream 🔥',
        discordId: 'Flamestream#3806',
      },
      19: {
        file:'19.png',
        author: 'Flamestream 🔥',
        discordId: 'Flamestream#3806',
      },
      20: {
        file:'20.png',
        author: 'Flamestream 🔥',
        discordId: 'Flamestream#3806',
      },
      21: {
        file:'21.png',
        author: 'poop dealer',
        discordId: '🌌💮𝓢𝐏ε𝓵ｌ 🔮ғ𝕋𝒽𝐞𝓓έ𝐚ｄ🌸🌆🌇🌺#9380',
      },
      22: {
        file:'22.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      23: {
        file:'23.png',
        author: 'Fen',
        discordId: 'FenriRez#6117',
      },
      24: {
        file:'24.png',
        author: 'Fen',
        discordId: 'FenriRez#6117',
      },
      25: {
        file:'25.png',
        author: 'Fen',
        discordId: 'FenriRez#6117',
      },
      26: {
        file:'26.png',
        author: 'Rama Andiasmat',
        discordId: 'RamaDiscord27#9564',
      },
      27: {
        file:'27.png',
        author: 'Rama Andiasmat',
        discordId: 'RamaDiscord27#9564',
      },
      28: {
        file:'28.png',
        author: 'Rama Andiasmat',
        discordId: 'RamaDiscord27#9564',
      },
      29: {
        file:'29.png',
        author: '.: 🌹 :.',
        discordId: 'Jay-Aero#9403',
      },
      30: {
        file:'30.png',
        author: '.: 🌹 :.',
        discordId: 'Jay-Aero#9403',
      },
      31: {
        file:'31.png',
        author: '.: 🌹 :.',
        discordId: 'Jay-Aero#9403',
      },
      32: {
        file:'32.png',
        author: '.: 🌹 :.',
        discordId: 'Jay-Aero#9403',
      },
      33: {
        file:'33.png',
        author: 'The_unholy_potato (Nichan)',
        discordId: 'The_unholy_potato (Nichan)#3771',
      },
      34: {
        file:'34.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      35: {
        file:'35.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      36: {
        file:'36.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      37: {
        file:'37.png',
        author: 'poop dealer',
        discordId: '🌌💮𝓢𝐏ε𝓵ｌ 🔮ғ𝕋𝒽𝐞𝓓έ𝐚ｄ🌸🌆🌇🌺#9380',
      },
      38: {
        file:'38.png',
        author: 'poop dealer',
        discordId: '🌌💮𝓢𝐏ε𝓵ｌ 🔮ғ𝕋𝒽𝐞𝓓έ𝐚ｄ🌸🌆🌇🌺#9380',
      },
      39: {
        file:'39.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      40: {
        file:'40.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      41: {
        file:'41.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      42: {
        file:'42.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      43: {
        file:'43.png',
        author: 'Barsik',
        discordId: 'Barsik#9758',
      },
      44: {
        file:'44.png',
        author: 'Tails, the Toe Tailed Fox',
        discordId: 'Brownie-Lolipop#9003',
      },
    },
    selectedIds: ['5', '4', '20', '1', '40', '28', '19', '3', '30', '41', '33', '25', '24', '23', '22', '11', '6', '27', '26', '44', '42', '34', '32', '31', '18', '13', '12', '2', '39', '38', '37', '29', '17', '16', '14', '10', '9', '8', '7'].slice(0, 12),
    maxSelected: false,
  }),

  computed: {
    displayedIds() {
      return this.maxSelected ? this.selectedIds : Object.keys(this.images);
    },
  },

  methods: {
    async handleImageClick(/*imgId*/) {

      this.maxSelected = !this.maxSelected;

      // const { selectedIds } = this;

      // const idx = selectedIds.indexOf(imgId);
      // if (~idx) {
      //   selectedIds.splice(idx, 1);
      // } else {
      //   if (this.maxSelected)
      //     return;
      //   selectedIds.push(imgId);
      // }
      // this.sendState();
    },

    async getState() {
      const resp = await fetch('/api/own-vote');
      let data;
      try {
        const body = await resp.json();
        data = body.data
      } catch (err) {
        // Do nothing
        console.error('Invalid data received from server');
      }
      if (Array.isArray(data)) {
        const validKeys = Object.keys(this.images);
        this.selectedIds = data.filter(i => validKeys.includes(i));
      }
    },

    sendState: debounce(async function() {
      await fetch('/api/own-vote/update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: this.selectedIds,
        }),
      })
    }, 1000),
  },

  async created () {
    this.$vuetify.theme.dark = true
    // try {
    //   await this.getState();
    // } catch (err) {
    //   // Do nothing
    // }
    this.ready = true;
  },
};
</script>

<style>
* {
  box-sizing: border-box;
  transition: all 1s;
}
</style>
